import { getOrderForOrderStatus } from "@bevco/Services/OrderService";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
  chain,
  RequestDataFromApi,
} from "@insite/client-framework/Store/Data/Orders/Handlers/LoadOrderByOrderNumber";

replaceInChain(chain, RequestDataFromApi, async props => {
  try {
    props.apiResult = await getOrderForOrderStatus(props.apiParameter);
  } catch (error) {
    if ("status" in error && error.status === 404) {
        props.dispatch({
            type: "Data/Orders/FailedToLoadOrder",
            orderNumber: props.parameter.orderNumber,
            status: 404,
        });
        return false;
    }
    throw error;
  }
});
